(function () {
  'use strict';

  /* global _ */
  class VeiculosCtrl {
    constructor($timeout, Uos, UoArvoreNivel, VeiculosDonoService, ServiceVfiltro, FactoryVfiltro, $translate) {
      this.timeout = $timeout;
      this.veiculos = [];
      this.selecionados = [];
      this.uoService = Uos;
      this.uoArvoreNivel = UoArvoreNivel;
      this.selecao = {};
      this.veiculosService = VeiculosDonoService;
      this.uos = [];
      this.listFail = [];
      this.uosDaMesmaArvore = [];
      this.todasAsEntidades = false;
      this.limitOrigem = 10;
      this.limitDestino = 10;
      this.translate = $translate;

      ServiceVfiltro.init(FactoryVfiltro.get([]))
        .then(() => {
          this.roleCadastrar = ServiceVfiltro.factoryVfiltro.authenticator.hasRole('VEICULO_PERMISSAO_EDITAR');
          this.init(ServiceVfiltro.factoryVfiltro.user);
        });
    }

    loadMoreOrigem() {
      this.limitOrigem += 10;
    }

    loadMoreDestino() {
      this.limitDestino += 10;
    }

    init(user) {
      this.user = user;
      this.carregarUos(this.user.uo.id);
    }

    carregarUos() {
      this.uoService.getFilhas(this.user.uo.id).then(data => this.uos = this.uoArvoreNivel.converterEmLista(data.plain()));
    }

    recarregarVeiculos() {
      this.selecionados = [];
      this.veiculos = [];
      this.veiculosService.getVeiculos(this.selecao.origem.id).then(data => this.veiculos = data.plain());
    }

    carregarVeiculos() {
      const service = this.uoService.getArvoreDaUo(this.selecao.origem.id);
      this.uosDaMesmaArvore = [];
      this.selecao.destino = null;
      this.todasAsEntidades = false;
      service.then(data => this.uosDaMesmaArvore = this.uoArvoreNivel.converterEmLista(data.plain()));
      this.recarregarVeiculos();
    }

    todosVeiculos() {
      if (this.todasAsEntidades) {
        this.selecionados = this.veiculos;
      } else {
        this.limparSelecao();
      }
    }

    limparSelecao() {
      this.selecionados = [];
      this.todasAsEntidades = false;
    }

    salvar() {
      this.veiculosService
        .mover(this.selecionados.map(veiculo => veiculo.id), this.selecao.destino.id)
        .then(response => {
          let erro = false;
          response.forEach(item => {
            let idVeiculo = Number(Object.keys(item)[0]);
            if (item[idVeiculo] === false) {
              erro = true;
            }
          });

          if (!erro) {
            this.alert = {
              display: true,
              alertClass: 'alert-success',
              alertMessage: this.translate.instant('core-permissoes.organizacao.transferenciaDeVeiculos.alertMessages.success')
            };
          } else {
            this.alert = {
              display: true,
              alertClass: 'alert-danger',
              alertMessage: this.translate.instant('core-permissoes.organizacao.transferenciaDeVeiculos.alertMessages.cannotBeTransferred')
            };
          }
          this.recarregarVeiculos();
        },
        () => {
          this.recarregarVeiculos();
          this.alert = {
            display: true,
            alertClass: 'alert-warning',
            alertMessage: this.translate.instant('core-permissoes.organizacao.transferenciaDeVeiculos.alertMessages.defaultError')
          };
        });
    }

    setItens(e) {
      this.timeout(() => {
        const valueInput = angular.copy(e.search);
        _.uniq(this.buildItens(valueInput))
        .forEach(item => {
          e.select(item);
        });
        e.search = '';
      }, 100);
    }

    buildItens(valueInput) {
      const regex = /(,|;)/;
      return valueInput
      .split(regex)
      .filter(e => !regex.exec(e))
      .filter(e => !!e)
      .map((i) => {
        const item = this.buildSearch(i),
            search = this.veiculos.find(x => this.buildSearch(`${x.prefixo} - ${x.placa}`).includes(item)),
            repetido = !this.selecionados.some(x => this.buildSearch(`${x.prefixo} - ${x.placa}`).includes(item));
        if (search && repetido) {
          return search;
        }
        if (!this.listFail.some(x => this.buildSearch(x).includes(item)) && repetido) {
          this.listFail.push(i);
        }
        return null;
      })
      .filter(e => !!e);
    }

    buildSearch(item) {
      return item.replace(/(\s|-)/g, '').toLowerCase();
    }

    removeInvalidItem(index) {
      this.listFail = this.listFail.filter((item, i) => i !== index);
    }
  }

  /**
   * @ngdoc object
   * @name veiculos.controller:VeiculosCtrl
   *
   * @description
   *
   */
  angular
    .module('veiculos')
    .controller('VeiculosCtrl', VeiculosCtrl);
}());
